import React from 'react';
import { LazyComponent } from '../../utils/LazyComponent';
import ThumbnailPlaceholder from '../../utils/ThumbnailPlaceholder';
import { Link } from 'react-router-dom';
import { getProject, getProjectHero, projectUrl } from '../../utils/projectsData';
import { playNextNote, HOVER_COLORS } from '../../utils/hoverMelody';

export default function ThingThumbnail({ imageIndex, linkState }) {
  const project = getProject(imageIndex);
  if (!project) return null;

  const colour = HOVER_COLORS[imageIndex % HOVER_COLORS.length];

  return (
    <LazyComponent
      fallback={<ThumbnailPlaceholder />}
      rootMargin="100px"
    >
      <Link
        to={projectUrl(project)}
        state={linkState}
        className="tile-link"
        style={{ '--hover-color': colour }}
        onMouseEnter={playNextNote}
      >
        <ThumbnailPlaceholder />
        {project.hero && (
          <img
            src={getProjectHero(imageIndex)}
            alt={project.title}
            loading="lazy"
          />
        )}
        {/* the hover state: the image inverts and the title sits over it,
            marked out in black so it reads over whatever is underneath. The
            inner span is what carries the black, so it hugs the lines of text
            rather than boxing the whole title. */}
        <span className="tile-hover" aria-hidden="true">
          <span className="tile-hover-title">
            <span className="tile-hover-mark">{project.title}</span>
          </span>
        </span>
      </Link>
    </LazyComponent>
  );
}
